import React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import ThemeToggle from './ThemeToggle';

const NavBarContainer = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: ${props => props.theme.colors.background};
  border-bottom: 1px solid ${props => props.theme.colors.border};
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 10px ${props => props.theme.colors.shadow};
`;

const NavBarContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
  height: 70px;
  
  @media (max-width: 768px) {
    padding: 0 1rem;
    height: 60px;
  }
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  flex: 1;
  
  @media (max-width: 768px) {
    gap: 1rem;
  }
`;

const NavTitle = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${props => props.theme.colors.text};
  white-space: nowrap;
  
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const NavTabs = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const NavTab = styled(Link)`
  padding: 0.6rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  text-decoration: none;
  color: ${props => props.theme.colors.text};
  background: ${props => props.$isActive 
    ? props.theme.colors.activeGradient
    : 'transparent'
  };
  border: 1px solid transparent;
  transition: all 0.3s ease;
  white-space: nowrap;
  min-height: 44px;
  display: flex;
  align-items: center;
  
  &:hover {
    background: ${props => props.$isActive
      ? props.theme.colors.activeGradientHover
      : props.theme.colors.borderLight
    };
  }
  
  @media (max-width: 768px) {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
  }
  
  @media (max-width: 480px) {
    padding: 0.4rem 0.8rem;
    font-size: 0.85rem;
  }
`;

const ThemeToggleWrapper = styled.div`
  /* Override ThemeToggle's absolute positioning */
  position: relative;
  
  /* Reset the nested component's positioning */
  > div {
    position: static;
  }
`;

const NavBar = () => {
  const { themeData } = useTheme();
  const location = useLocation();
  
  return (
    <NavBarContainer theme={themeData}>
      <NavBarContent>
        <LeftSection>
          <NavTitle theme={themeData}>Singularity Countdown</NavTitle>
          
          <NavTabs>
            <NavTab 
              to="/" 
              $isActive={location.pathname === '/'} 
              theme={themeData}
            >
              Home
            </NavTab>
            <NavTab 
              to="/timeline" 
              $isActive={location.pathname === '/timeline'} 
              theme={themeData}
            >
              Timeline
            </NavTab>
            <NavTab 
              to="/about" 
              $isActive={location.pathname === '/about'} 
              theme={themeData}
            >
              About
            </NavTab>
          </NavTabs>
        </LeftSection>
        
        <ThemeToggleWrapper>
          <ThemeToggle />
        </ThemeToggleWrapper>
      </NavBarContent>
    </NavBarContainer>
  );
};

export default NavBar;